// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerSample_root__3eY7l","title":"AnswerSample_title__RHXF1"};